import React from 'react';

const NotFoundPage = ({ brandSettings }) => (
  <main className="page page--booking">
    <header className="hero hero--fun">
      <div className="hero-brand">
        {brandSettings?.logoUrl ? (
          <img className="brand-logo" src={brandSettings.logoUrl} alt={brandSettings.businessName || 'Brand logo'} />
        ) : null}
        <span className="brand-name">{brandSettings?.businessName || 'Build-A-Bear Workshop'}</span>
      </div>
      <div className="hero-title">
        <h1>Page not found</h1>
      </div>
      <p className="subtitle">This page is unavailable. Choose a workshop to start a booking.</p>
    </header>

    <section className="not-found-actions">
      <div className="stack">
        <p className="muted">The link may be out of date or incomplete.</p>
        <div>
          <a className="btn btn-primary" href="/">
            Choose a workshop
          </a>
        </div>
      </div>
    </section>
  </main>
);

export default NotFoundPage;
